"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var SupplierPriceRecalculation =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SupplierPriceRecalculation, _DomainObject_1$Domai);

  /**
   * Wrapper domain object for purchase price currency recalculation result.
   * @param supplierAgreementId intern id of supplierAgreement
   * @param regularPurchasePriceRecalculate
   * @param promoPurchasePriceRecalculate
   * @param promoPurchasePricePlusRecalculate
   */
  function SupplierPriceRecalculation(supplierAgreementId, regularPurchasePriceRecalculate, promoPurchasePriceRecalculate, promoPurchasePricePlusRecalculate) {
    var _this;

    _classCallCheck(this, SupplierPriceRecalculation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierPriceRecalculation).call(this));
    _this.supplierAgreementId = supplierAgreementId;
    _this.regularPurchasePriceRecalculate = regularPurchasePriceRecalculate;
    _this.promoPurchasePriceRecalculate = promoPurchasePriceRecalculate;
    _this.promoPurchasePricePlusRecalculate = promoPurchasePricePlusRecalculate;
    return _this;
  }

  return SupplierPriceRecalculation;
}(DomainObject_1.DomainObject);

exports.SupplierPriceRecalculation = SupplierPriceRecalculation;

SupplierPriceRecalculation.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SupplierPriceRecalculation.name);
  return {
    supplierAgreementId: builder.id('supplierAgreementId'),
    regularPurchasePriceRecalculate: builder.opt(builder.bigNum('regularPurchasePriceRecalculate')),
    promoPurchasePriceRecalculate: builder.opt(builder.bigNum('promoPurchasePriceRecalculate')),
    promoPurchasePricePlusRecalculate: builder.opt(builder.bigNum('promoPurchasePricePlusRecalculate'))
  };
}();